export default __webpack_public_path__ + "static/media/salt.4da65e76.gif";